export const credentials = {
  apiKey: 'AIzaSyAm2rUqrFJlvs1wpiaEfxJYFLF7IKcNFfw',
  authDomain: 'c2cstory4.firebaseapp.com',
  databaseURL: 'https://c2cstory4.firebaseio.com',
  projectId: 'c2cstory4',
  storageBucket: 'c2cstory4.appspot.com',
  messagingSenderId: '159693458071',
  appId: '1:159693458071:web:139286565eac911e'
};
